import { Component, OnInit, ViewChild } from "@angular/core";
import { NavService } from "../../../_services/_nav.service";
import { AutenticacionService } from "../../../_services/autenticacion.service";
import { Router } from "@angular/router";
import { Table } from "primeng/table";
import { Funcionalidad } from "../../../_models/funcionalidad";
import { SarlaftService } from "../../../_services/sarlaft.service";
import { NivelesSarlaft } from "../../../_models/sarlaft-niveles";
import { tap } from "rxjs/operators";
import { ConfirmationService } from "primeng/api";

@Component({
  selector: "app-sarlaft-niveles",
  templateUrl: "sarlaft-niveles.component.html",
  styleUrls: ["sarlaft-niveles.component.css"],
})
export class SarlaftNivelesComponent implements OnInit {
  niveles: NivelesSarlaft[] = [];
  cargaNiveles = true;
  columnas: any[];
  busqueda: string;
  @ViewChild("dt", { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private router: Router,
    private sarlaftService: SarlaftService,
    private conServicio: ConfirmationService
  ) {}

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find((x) => x.ruta === "apl/sarlaft");
    if (mn) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_NIVELDERIESGO' ), sort: true },
      { field: 'nombreTipoProcesoCredito', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_TIPODEPROCESO' ), sort: true },
      { field: 'rangoMinimo', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_RANGOMINIMO' ), sort: true },
      { field: 'rangoMaximo', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_RANGOMAXIMO' ), sort: true },
      { field: 'descripcion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_DESCRIPCION' ), sort: true },
      { field: 'nombreDecisionProcesoSarlaft', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_DECISION' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.cargarTabla();
  }
  inhabilitarCanal(nivel: NivelesSarlaft) {
    nivel.indicadorHabilitado = false;
    this.sarlaftService.verificarRango(nivel).subscribe(
      (response) => {
        if (!response.estado) {
          this.conServicio.confirm({
            icon: "fa fa-question-circle",
            header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
            message: this.navServicio.buscarMensaje("SARLAFT.MSG_CONFIRMACIONELIMINADO"),
            accept: () => {
              this.sarlaftService.actualizarBulk(response.listado).subscribe(
                (rta) => {
                  this.cargarTabla();
                  this.cargaNiveles = false;
                  this.navServicio.setMesage(4, {
                    severity: "success",
                    summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
                    detail: this.navServicio.buscarMensaje("SARLAFT.MSG_NIVELACTUALIZADO"),
                  });
                },
                (error) => {
                  this.cargaNiveles = false;
                  this.navServicio.setMesage(3);
                }
              );
            },
            reject: () => {
              this.cargaNiveles = false;
            },
          });
        } else if (response.estado) {
          this.conServicio.confirm({
            icon: "fa fa-question-circle",
            header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
            message: this.navServicio.buscarMensaje("SARLAFT.MSG_CONFIRMACIONELIMINADO"),
            accept: () => {
              this.sarlaftService.actualizarBulk(response.listado).subscribe(
                (rta) => {
                  this.cargarTabla();
                  this.cargaNiveles = false;
                  this.navServicio.setMesage(1);
                },
                (error) => {
                  this.cargaNiveles = false;
                  this.navServicio.setMesage(3);
                }
              );
            },
            reject: () => {
              this.cargaNiveles = false;
            },
          });
        } else {
          this.navServicio.setMesage(3);
          this.cargaNiveles = false;
        }
      },
      (error) => {
        this.navServicio.setMesage(3);
        this.cargaNiveles = false;
      }
    );
  }
  cargarTabla() {
    this.sarlaftService
      .obtenerNivelesSarlaft()
      .pipe(
        tap((sarlaft: NivelesSarlaft[]) => {
          this.niveles = sarlaft.filter((n) => n.indicadorHabilitado);
          this.cargaNiveles = false;
          this.tabla.filterGlobal(this.busqueda, "contains");
        })
      )
      .subscribe();
  }
  crearCanal() {
    this.router.navigate(["apl/sarlaft/niveles-agregar"]);
  }
  editarCanal(nivel: NivelesSarlaft) {
    this.router.navigate([
      "apl/sarlaft/niveles-actualizar/" + nivel.idRiesgosSarlaftniveles,
    ]);
  }
  setBusqueda() {
    console.log(this.busqueda);
    this.navServicio.setSearch("sarlaftniveles.component", this.busqueda);
  }
}
